<template>
  <div class="home">
    <ShadowView ref="shadow_input">
      <div class="inputView" :style="{margin:'auto', width:`${screen_width-30}px`}">
        <InputView type="post" :post-type="postType" @publish="publish"/>
      </div>
    </ShadowView>

    <div class="home__header">
      <div class="home_title">
        <p class="title_word">社区朋友圈</p>
        <span class="logout" @click.stop="quit()" v-if="loginStatus">退出</span>
        <span class="logout" @click.stop="login()" v-if="!loginStatus">登录</span>
        <span class="message" @click.stop="jumpToMessage()">消息 <span class="home__message__count" v-if="message && message.unread_total_count > 0">{{ message.unread_total_count }}</span></span>
      </div>
      <span class="home__message">
        <span class="sendPost" @click.stop="openInputView()">发帖</span>
      </span>
    </div>
    <div class="home">
        <PostList ref="postList" :post-type="postType" :follow-type="followType" :owner-info="userInfo" />
    </div>
    
  </div>

  </template>
  
  <script>
  // @ is an alias to /src
  import InputView from "./InputView.vue";
  import PopularityRank from "../PopularityRank.vue";
  import PostList from './PostList.vue';
  import CompanyList from '../CompanyList.vue';
  import CompanyRank from '../CompanyRank.vue';
  import WorkListTop from '../WorkListTop.vue'
  import CodeQA from '../CodeQA.vue'
  import CreateQuestion from '../components/CreateQuestion.vue'
  import Diary from '../Diary.vue'
  import Capillaries from '../components/Capillaries.vue'
  import ScratchHome from '../scratch/Home.vue'
  import AppStoreHome from '../AppStoreHome.vue'
  import UserGuide from '../components/UserGuide.vue'
  import ActivityHome from '../activity/Home.vue'
  import SchoolHome from '../school/SchoolList.vue'
  import ShadowView from './ShadowView' 

  import { types as CommunityTypes } from "@/store/modules/community";
  import { types as LoginTypes } from "@/store/modules/login";
  import { types as BrandTypes } from "@/store/modules/brand";
  import { types as ToastTypes } from "@/store/modules/toast";
  import { mapState, mapGetters, mapMutations, mapActions } from "vuex";
  
  import {
    TITLE,
    BG,
    AVATAR_BG,
    BRAND_ICON,
    IMG_BACK,
    IMG_MESSAGE_ICON,
    IMG_OJ_ICON,
    IMG_WORK_ICON,
    IMG_FRIEND_ICON,
    IMG_COMPANY_ICON,
    IMG_BACK_TOP,
    IMG_BANNER,
    IMG_SEARCH,
    IMG_DEFAULT_AVATAR,
    IMG_SCRATCH_ALL_WORKS
  } from "@/assets";
  import { Utils, GET_VALUE, REMOVE_VALUE } from "@/utils";
  // import DayTimer from "./components/DayTimer"
  
  export default {
    name: "home",
    components: {
      InputView,
      PopularityRank,
      PostList,
      CompanyList,
      CompanyRank,
      WorkListTop,
      CreateQuestion,
      Diary,
      Capillaries,
      ScratchHome,
      AppStoreHome,
      UserGuide,
      CodeQA,
      ActivityHome,
      SchoolHome,
      ShadowView
      // DayTimer
    },
    data () {
      return {
        images: {
          title: TITLE,
          bg: BG,
          avatar_bg: AVATAR_BG,
          brand_icon: BRAND_ICON,
          back: IMG_BACK,
          message_icon: IMG_MESSAGE_ICON,
          oj_icon: IMG_OJ_ICON,
          work_icon: IMG_WORK_ICON,
          friend_icon: IMG_FRIEND_ICON,
          company_icon: IMG_COMPANY_ICON,
          back_top: IMG_BACK_TOP,
          banner: IMG_BANNER,
          search: IMG_SEARCH,
          default_avatar: IMG_DEFAULT_AVATAR,
          scratch_all_works:IMG_SCRATCH_ALL_WORKS
        },
        can_goback: window.history.length > 1 ? true : false,
        postType: "common",
        followType: "all",
        back_top: false,
        show_input_shadow: false,
        rightNotArr:['scratch','codeQA'],//右边不显示的postType
  
        // searchView
        searchView:{
          show: false,
          content: ''
        },
  
        //日记相关
        showDiary: false,
        diaryPw: "",
        pwType: 'input',//reset 重置密码，confirm确认密码,input输入密码
  
        // 用户引导
        show_user_guide: false,

        screen_width: window.innerWidth,
        screen_height: window.innerHeight
      };
    },
    computed: {
      ...mapState({
        loginStatus: state => state.login.status,
        userInfo: state => state.login.userInfo,
        message: state => state.login.message,
        current_ad: state => state.video_course.current_ad,
        watch_can_send: state => state.community.watch_can_send
      })
    },
  
    methods: {
      ...mapMutations({
        showToast: ToastTypes.SHOW,
        updateNewPostCount: CommunityTypes.UPDATE_NEW_POST_COUNT
      }),
      ...mapActions({
        dependLoginStatus: LoginTypes.LOAD_LOGIN_STATUS,
        fetchLogin: LoginTypes.FETCH_LOGIN,
        fetchLogout: LoginTypes.FETCH_LOGOUT,
        fetchOwnInfo: LoginTypes.FETCH_USERINFO,
        fetchUnreadMessage: LoginTypes.FETCH_UNREAD_MESSAGE,
        fetchCreateEvent: CommunityTypes.FETCH_CREATE_EVENT,
        fetchNewPostCount: CommunityTypes.FETCH_NEW_ADD_POST_COUNT,
        fetchIsCanSend: CommunityTypes.FETCH_IS_CAN_SEND
      }),
      ...Utils,
      // 返回事件
      goBack () {
        // 登录状态判断
        this.dependLoginStatus().then(()=>{
          location.href = "/index/CogaSelect"
        })
      },
      // 我的关注列表
      goMyFollower(type){
        let callback = () => {
        this.$router.push(`/myfollower?type=${type}`);
        }
        this.dependLoginStatus().then(callback)
      },
      // 设置帖子类型
      setPostType (type) {
        // 切换 tab，刷新右上角消息数和左边圈子未读数
        this.fetchNewPostCount();
        this.fetchUnreadMessage();
  
        if (type === this.postType) return;
        
        this.postType = type;
        this.$router.replace(`/?tag=${type}`);
        if(['company'].includes(type)){
          console.log("公司圈未读数置为0")
          this.updateNewPostCount({"company_count":0});
        }else if (["diary", "appstore", "scratch"].includes(type)) {
          // 公司圈的话，刷新新增帖子个数, 
          this.fetchNewPostCount();
        } else if (['work', 'common', 'contest', 'science', 'move', 'mago', 'cube', 'video', 'piskel'].includes(type)) {
          if (this.$refs.postList) {
            console.log("改变了帖子的类型：重新请求", type)
            this.$refs.postList.loadData("reset", type, this.followType)
          }
        }
  
      },
      // 设置帖子关注类型
      setFollowType (type) {
        let callback = () => {
        this.followType = type;
        if (this.$refs.postList) {
          console.log("改变了关注的类型：重新请求", type)
          this.$refs.postList.loadData("reset", this.postType, type)
        }
        }
        if(type === 'follow'){
          this.dependLoginStatus().then(callback)
        }else{
          callback()
        }
      },
      // 跳到个人主页
      jumpToProfile (tag) {
        let callback = () => {
        if (!tag) {
          tag = "post";
        }
        let user_id = this.userInfo.user_id;
        // this.$router.push(`/profile/${owner}`);                     //方式 0   /profile/123
        // this.$router.push({name:'profile', params:{user:owner}});   //方式 1   /profile/123
        // this.$router.push({path: `/profile/${owner}`});             //方式 2   /profile/123
        // this.$router.push({path: 'profile', query:{user:owner}});   //方式 3   /profile?user=123
        // this.$router.push({path:'/profile', params:{user:owner}});  //这种的 params 无效
  
        this.$router.push(`/profile/${user_id}?tag=${tag}`);
        // this.$router.push({path:`/profile/${user_id}/`, query:{tag:tag}})
        }
        // 登录状态判断
        this.dependLoginStatus().then(callback)
      },
      // 跳到消息中心页
      jumpToMessage () {
        // 登录状态判断
        this.dependLoginStatus().then(()=>{
          this.$router.push(`/mobilemessage`);
        })
      },
      // 跳到全部作品页
      jumpToAllWorks(){
        this.$router.push(`/scratch/allworkscontainer`)
      },
      // 退出登录
      quit(){
        REMOVE_VALUE("Token")
        REMOVE_VALUE("face2face_token")
        REMOVE_VALUE("username")
        REMOVE_VALUE("ownerInfo")
        REMOVE_VALUE("Token", 'cookie')
        // location.reload()
        this.$router.go(0);
        // this.fetchLogout();
      },
      // 登录
      login(){
        let newUrl = location.href
        location.href = `/index/Login?ret=${newUrl}`
      },
      // 去其他网页
      goWebSite (url) {
        if(url.includes("TaskList")){
          // 登录状态判断
          this.dependLoginStatus().then(()=>{
            window.open(url, '_blank')
          })
        }else{
          window.open(url, '_blank')
        }
      },
      // 回到顶部
      backTopEvent () {
        document.documentElement.scrollTop = 0
      },
      // 监听滚动事件
      handleScroll(e) {
        var that = this;
        let scrollTop =
          window.pageYOffset ||
          document.documentElement.scrollTop ||
          document.body.scrollTop;
        
        // if(e && e.target){
        //   scrollTop = e.target.scrollTop
        // }
  
        if (scrollTop > 0) {
          // 显示回到顶部按钮
          this.back_top = true;
        } else {
          // 隐藏回到顶部按钮
          this.back_top = false;
        }
      },
      // 打开帖子输入框
      openInputView() {
        let callback = () => {
          this.$refs.shadow_input.showShadowView();
        }
        this.dependLoginStatus().then(callback)
      },
      hideInputView () {
        this.$refs.shadow_input.hideShadowView();
      },
      // 打开出题框
      openQuestionView () {
        let callback = ()=>{
          // this.$refs.createCompany.showShadowView();
          this.fetchIsCanSend({"tag":"problem"})
        }
        this.dependLoginStatus().then(callback)
      },
      // 搜索按钮点击事件
      openSearchView(){
        if(this.searchView.show){
          // 调搜索 api
          if (this.$refs.postList) {
            console.log("按帖子内容进行搜索：重新请求", this.searchView.content)
            this.$refs.postList.loadData("reset", this.postType, this.followType, this.searchView.content)
            this.searchView.content = ""
            this.searchView.show = false;
          }
        }else{
          // 打开搜索框
          this.searchView.show = !this.searchView.show;
        }
      },
  
      //-------------inputView 组件的回调函数
      //发帖子
      publish (type, data) {
        data["type"] = type;
        console.log(data);
        this.fetchCreateEvent(data);
        this.hideInputView();
      },
      
     
      // 聚焦在pwinput上
      focusPwInput () {
        if (this.diaryPw.length > 3) {
          this.diaryPw = this.diaryPw.substr(0, 3)
        }
        this.$refs.pwInput.focus();
      },
      // 重置密码相关
      resetPw () {
      }
    },
    created () {
      window.addEventListener("scroll", this.handleScroll);
  
  
    },
    destroyed () {
      window.removeEventListener("scroll", this.handleScroll);
    },
    mounted () {
      if(GET_VALUE('user_guide')){
        this.show_user_guide = false
      }else{
        this.show_user_guide = true
      }
      if (this.$route.query.tag) {
        this.postType = this.$route.query.tag;
      } else {
        this.postType = "common";
      }
      this.fetchNewPostCount();
      if(this.loginStatus){
      this.fetchOwnInfo();
      this.fetchUnreadMessage();
      }
    }
  };
  </script>
  
  <style lang="less" scoped>
  .home {
    /* background-color: #6b45e1; */
    width: 100%;
    height: 100%;

    /* background-position: center; */
    /* background-repeat: no-repeat; */
    background-size: 100%;
    position: relative;
  }
  .home__message {
    display: flex;
    flex-direction: row;
    align-items: center;
    color: #FF7B00;
    cursor: pointer;
    margin-left: 20px;
    margin-top: 12px;
  }
  .sendPost {
    background-color: #ffffff;
    border-style: solid;
    border-width: 1px;
    padding: 4px 10px;
    border-radius: 15px;
    font-size:16px;
  }
  .home_title{
    background-color: #6b45e1;
  }
  .home_title .title_word{
    font-size:18px;
    text-align: center;
    padding: 12px;
    color:#ffffff;
  }
  .logout,.message{
    font-size: 15px;
    background: #ffffff;
    color: #FF7B00;
    border-radius: 15px;
    border-style: solid;
    border-width: 1px;
    padding: 2px 8px;
    position: absolute;
  }
  .logout{
    right: 8px;
    top: 14px;
  }
  .message{
    left:8px;
    top:14px;
  }
  .inputView{
    width:calc(100% - 30px);
    margin-left: 15px;
  }
  </style>
  